import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { api, setTokens, clearTokens, getToken } from './api.js'

const Ctx = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      if (getToken()) { try { setUser(await api.me()) } catch { clearTokens() } }
      setLoading(false)
    })()
    const onLogout = () => setUser(null)
    window.addEventListener('gpdf:logout', onLogout)
    return () => window.removeEventListener('gpdf:logout', onLogout)
  }, [])

  const login = useCallback(async (u, p) => {
    const t = await api.login(u, p)
    setTokens(t.access_token, t.refresh_token)
    const me = await api.me()
    setUser(me)
    return me
  }, [])

  const logout = useCallback(() => { clearTokens(); setUser(null) }, [])

  return <Ctx.Provider value={{ user, loading, login, logout }}>{children}</Ctx.Provider>
}

export const useAuth = () => useContext(Ctx)

export function RequireAuth({ children }) {
  const { user, loading } = useAuth()
  const loc = useLocation()
  if (loading) return <div className="splash">Ładowanie…</div>
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />
  return children
}

export function RequireAdmin({ children }) {
  const { user } = useAuth()
  if (user?.role !== 'admin') return <Navigate to="/" replace />
  return children
}
